import { Button, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalHeader } from 'ui/modal';
import { localizeNumber } from 'utils/l10n';

import { StyledModalBody } from './Styled';
import { useListId, useUpdateDynamicListMutation, useTranslation } from '../../hooks';
import { useModalsContext } from '../../contexts/modals';
import { useListReferencesContext } from '../../contexts/listReferences';
import { useListDetailsContext } from '../../contexts/listDetails';
import { UpdateDynamicListParams } from '../../types';
import { useSegmentationQueryContext } from '../../contexts/segmentationQuery';

export const testIds = {
  cta: 'segmentation-udl-banner-cta',
  buttonUpdate: 'segmentation-udl-btn-update',
  modal: 'segmentation-udl',
};

export const UpdateDynamicListQueryModal = () => {
  const { t } = useTranslation();
  const { searchQuery } = useSegmentationQueryContext();
  const listId = useListId();
  const { list } = useListDetailsContext();

  const { hideModal: closeModal } = useModalsContext();
  const { totalCount } = useListReferencesContext();
  const { mutate: updateDynamicListQuery } = useUpdateDynamicListMutation();

  const updateDynamicList = () => {
    const params: UpdateDynamicListParams = {
      emailListId: listId as number,
      searchQuery,
    };

    updateDynamicListQuery(params);
  };

  return (
    <Modal id={testIds.modal} onClose={closeModal} isModalOpen>
      <ModalHeader>{t('modal.updateDynamicList.header')}</ModalHeader>
      <StyledModalBody>
        {t('modal.updateDynamicList.cta', {
          resourceName: list.name,
          count: totalCount,
          numTimes: localizeNumber(totalCount),
        })}
      </StyledModalBody>
      <ModalFooter>
        <Button
          onClick={updateDynamicList}
          size={BUTTON_SIZES.LARGE}
          data-test={testIds.buttonUpdate}
        >
          {t('modal.updateDynamicList.button.update')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
